import React from "react";
import { Container, Row, Col } from "reactstrap";
import TermsSections from "./TermsSections";
import '../../assets/css/termsconditions.css';

export default function TermsConditions() {
    return (
        <Container className="terms-container my-5">
            <Row>
                <Col lg="12">
                    <h1 className="mb-5 pb-3 fw-bold text-primary text-center">Terms & Conditions</h1>
                    <TermsSections />
                </Col>
            </Row>
        </Container>
    );
}
